<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useTestsStore } from '@stores';
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });
const route = useRoute();
const tests = useTestsStore();

const activeTab = ref(route.path);
const testId = route.params.testId;

const items = ref([
    { route: `/tests/${testId}/main`, label: computed(() => t('tests.tabs.main')), icon: 'pi pi-home' },
    { route: `/tests/${testId}/questions`, label: computed(() => t('tests.tabs.questions')), icon: 'pi pi-question-circle' },
    { route: `/tests/${testId}/preview`, label: computed(() => t('tests.tabs.preview')), icon: 'pi pi-list' },
]);

onMounted(async () => {
    await tests.getTest(testId);
});

const activeLabel = computed(() => items.value.find((item) => item.route === activeTab.value).label);
</script>

<template>
    <div class="test-tabs">
        <Tabs :value="activeLabel" class="mb-4 rounded-xl overflow-hidden">
            <TabList>
                <Tab v-for="tab in items" :key="tab.label" :value="tab.label" :disabled="!tests.main?.name && tab.route !== `/tests/${testId}/main`">
                    <router-link v-if="tab.route" v-slot="{ href, navigate }" :to="tab.route" custom>
                        <a v-ripple :href="href" @click="navigate" class="tab-item">
                            <i :class="tab.icon" />
                            <span>{{ tab.label }}</span>
                        </a>
                    </router-link>
                </Tab>
            </TabList>
        </Tabs>

        <router-view />
    </div>
</template>

<style scoped>
:deep.test-tabs .p-tab {
    @apply p-0;
}
.tab-item {
    @apply flex items-center gap-2 text-inherit p-4;
}
</style>
